var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('elevator-pitch-audio',{attrs:{"offer":_vm.offer}}),_c('opinion-audio',{attrs:{"offer":_vm.offer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }